/** Official DokaanDigit logo (vector traced from the artwork supplied by NTechEdge; files live in public/brand). */
export function Logo({ size = 56, withText = false }: { size?: number; withText?: boolean }) {
  // The mark viewBox height is 1380, the wordmark capital height matches the D proportion (size * 0.58)
  return (
    <span className="inline-flex items-center gap-2.5">
      <img src="/brand/logo-mark.svg" alt="DokaanDigit" width={Math.round(size * 0.96)} height={size} className="block shrink-0 select-none" draggable={false} />
      {withText && <img src="/brand/logo-wordmark.svg" alt="DokaanDigit" aria-hidden height={Math.round(size * 0.58)} width={Math.round(size * 0.58 * 5.99)} className="block shrink-0 select-none" draggable={false} />}
    </span>
  );
}
